import * as React from 'react';
import { Grid } from '@mui/material';
import { ReceiptBatchOverview } from './ReceiptBatchOverview';

import type { JSX } from 'react';

interface ReceiptBatchCommonViewProps {
  receiptsCount: number;
  totalAmount: number;
  ReceiptBatchCommonForm: React.ReactNode;
  ReceiptBatchImageInput: React.ReactNode;
  autoGenerateReceipts?: boolean;
}

export function ServiceProviderReceiptBatchCommonView({
  ReceiptBatchCommonForm,
  receiptsCount,
  totalAmount,
  ReceiptBatchImageInput,
  autoGenerateReceipts,
}: ReceiptBatchCommonViewProps): JSX.Element {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: autoGenerateReceipts ? 'flex-start' : 'stretch',
      }}
    >
      {ReceiptBatchCommonForm}
      <ReceiptBatchOverview
        receiptsCount={receiptsCount}
        totalAmount={totalAmount}
        ReceiptBatchImageInput={ReceiptBatchImageInput}
        autoGenerateReceipts={autoGenerateReceipts}
      />
    </Grid>
  );
}
